// Tailwind
import { variantJS, settings } from './tailwind';

import Primevue from './primevue';

// Validate
import validate from './validate';

// Toast Notification
import ToastNotification from './toast-notification';

// Vue Clipboard
//import VueClipboard from './vue-clipboard2';

// Vue masonry
import VueMasonry from './vue-masonry';

// V Tooltip
import VueTooltip from './v-tooltip';

// Vue GTM
import VueGtm from './vue-gtm';

// Chart.JS
import './chart-js';

// Intercom
import './intercom';

// Unhead
import unhead from './unhead';

export default (app) => {
    app.use(variantJS, settings);
    app.use(ToastNotification);
    app.use(VueTooltip);
    app.use(VueGtm);
    app.use(unhead);
    app.use(Primevue);
    app.use(VueMasonry);

    validate();
};
